export const environment = {
  production: false,
  //V1
  // apiUrl: "https://api-zeus.testing.retteralarm.de/api/v1/",
  //V2
  // apiUrl: "https://api-zeus.testing.retteralarm.de/api/v2/",
  //V3
  apiUrl: "https://api-zeus.testing.retteralarm.de/api/v3/",
  loginUrl: "https://my.testing.weberrescueworld.com/",
  loginBackUrl: "https://zeus.testing.retteralarm.de/auth/login",
  // loginBackUrl: "http://localhost:8100/auth/login",

  ACS_CONNECTION_STRING: "https://retteralarm.germany.communication.azure.com/",
  CRYPTO_KEY: "rescuedigitalprivatechat",
};
export const appInfo = {
    packageName :"com.ssncomputer.retterzeustest",
    appName : "RetterZeus-Test",
}